export const CLEAR = '@billing/CLEAR';
export const BILLING_LIST_REQUEST = '@billing/BILLING_LIST_REQUEST';
export const BILLING_LIST_SUCCESSFUL = '@billing/BILLING_LIST_SUCCESSFUL';
export const BILLING_LIST_FAILED = '@billing/BILLING_LIST_FAILED';
export const BILLING_SET_FILTER = '@billing/BILLING_SET_FILTER';
export const BILLING_SET_SCOPE = '@billing/BILLING_SET_SCOPE';
export const BILLING_SET_RESOLVED_PROFILE = '@billing/BILLING_SET_RESOLVED_PROFILE';
export const BILLING_FETCH_CANCELLED = '@billing/BILLING_FETCH_CANCELLED';
export const GET_ONGOING_TRIP_RECEIPTS = '@billing/GET_ONGOING_TRIP_RECEIPTS';
export const SET_ONGOING_TRIP_RECEIPTS_LOADING = '@billing/SET_ONGOING_TRIP_RECEIPTS_LOADING';
export const SET_ONGOING_TRIP_RECEIPTS = '@billing/SET_ONGOING_TRIP_RECEIPTS';

export const SCOPE_TRIPS = 'trips';
export const SCOPE_OTHERS = 'others';
